import { Directive, HostListener, inject, Input } from '@angular/core';
import { WINDOW } from '@forgerock/backstage-ui-core';
import { EverythingSearchResult } from './model/everything-search-result';
import { TabService } from './tab/tab.service';

@Directive({
  selector: '[appSearchResultLink]',
  standalone: true
})
export class SearchResultLinkDirective {
  @Input() appSearchResultLink: EverythingSearchResult;
  private window = inject(WINDOW);
  private tabService = inject(TabService);

  @HostListener('click', [ '$event' ])
  async handleResultClick(event: MouseEvent): Promise<void> {
    if (!event.metaKey) {
      event.preventDefault();
    }

    const { url } = this.appSearchResultLink;
    if (event.defaultPrevented) {
      this.window.location.assign(url);
    }
  }

}
